/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { Mapping } from '../../models/mapping';

export interface MappingsGet$Params {
  'Active-Tenant-Identifier': string;

/**
 * If provided it will filter the returned store mappings to just this storeId
 */
  storeId?: string;
}

export function mappingsGet(http: HttpClient, rootUrl: string, params: MappingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'result'?: {
'_links'?: HalJson;
} & Mapping & {

/**
 * Key to use in next requests to retrieve next page of store mappings
 */
'nextKey'?: string;
};
}>> {
  const rb = new RequestBuilder(rootUrl, mappingsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'result'?: {
      '_links'?: HalJson;
      } & Mapping & {
      
      /**
       * Key to use in next requests to retrieve next page of store mappings
       */
      'nextKey'?: string;
      };
      }>;
    })
  );
}

mappingsGet.PATH = '/om/mappings';
